<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                passive
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('irrigation.irrigation_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>

          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="51%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card">
              <div class="card-body">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.system') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>

          <el-dialog :title="title" :visible.sync="modals.create">
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    ref="sistema"
                    type="text"
                    :label="`${$t('irrigation.system')}: *`"
                    v-model="systemForm.name"
                    name="irrigation.system"
                    v-validate="modelValidations.name"
                    :error="getError('irrigation.system', true)"
                    :placeholder="`${$t('irrigation.irrigation_system')}...`"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.select_one_or_many_farms') }}*</label
                    >
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('systemForm.farms_id', farms)
                      "
                      collapse-tags
                      id="bussiness_systems"
                      clearable
                      multiple
                      class="select-primary custom-width-select bus-rels shadow-sm"
                      size="large"
                      v-model="systemForm.farms_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in farms"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              :border="true"
            >
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import store from '@/store';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import configTable from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      systemForm: {
        id: null,
        route: null,
        name: null,
        farms_id: [],
      },
      farms: null,
      rowData: {},
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: {},
      tableColumns: [],
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinForm, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    openModal(name) {
      if (name == 'create') {
        sessionStorage.removeItem('editForm');
        (this.title = i18n.t('irrigation.system_add')), this.$validator.reset();
        this.systemForm.name = null;
        this.systemForm.farms_id = null;
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    deleteSystem() {
      this.showHideLoading(true);
      this.systemForm.route = 'irrigation/systems';
      Axios.destroyMaster(this.systemForm)
        .then((response) => this.modifyTable(2, this.systemForm.id, response))
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(
            error.response.data.message ? error.response.data.message : error
          );
        });
    },

    handleDelete(index, row) {
      this.systemForm = row;
      SweetAlert.delete(this.systemForm.name).then((result) => {
        if (result.value) this.deleteSystem();
      });
    },

    handleEdit(index, row) {
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.title = i18n.t('irrigation.system_add') + ' ' + row.name;
      this.systemForm = Object.assign({}, row);
      this.errors.clear();
      this.systemForm.route = 'irrigation/systems';
      this.modals['create'] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (this.systemForm.farms_id.length == 0) {
          let sel = document.getElementById('bussiness_systems');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        if (isValid) {
          if (this.isCreate() && !sessionStorage.getItem('editForm')) {
            this.createSystem();
          } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            this.updateSystem();
          }
        }
      });
    },

    createSystem() {
      this.showHideLoading(true);
      this.systemForm.route = 'irrigation/systems';
      Axios.saveMaster(this.systemForm)
        .then((response) => {
          this.modifyTable(0, null, response);
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            ` ${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            `${i18n.t('common_words.alert')}...`
          );
          this.showHideLoading();
        });
    },

    updateSystem() {
      this.systemForm.route = 'irrigation/systems';
      this.systemForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
      Axios.updateMaster(this.systemForm)
        .then((response) => {
          this.modifyTable(1, this.systemForm.id, response);
          sessionStorage.removeItem('editForm');
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            ` ${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            `${i18n.t('common_words.alert')}...`
          );
          this.showHideLoading();
          sessionStorage.removeItem('editForm');
        });
    },

    exportToPDF() {
      let data = {};
      data.route = 'irrigation/systems/pdf';
      data.name_file = 'sistemas.pdf';

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'irrigation/systems/excel';
      data.name_file = 'sistemas.xlsx';

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },
  update() {
    sessionStorage.removeItem('editForm');
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('irrigation/systems'),
        Axios.getMasters('farms/farms/only'),
      ])
        .then((response) => {
          this.tableData = response[0].data.data;
          this.farms = this.concatAll(response[1].data.data);
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>

<style scoped></style>
